export function isJSON (str: string): boolean {
  try {
    JSON.parse(str)
    return true
  } catch (e: any) {
    return false
  }
}
